import { create } from 'zustand';
import {
  BannerSource,
  BannerStore,
} from '@/store/useBannerStore/useBannerStore.types';

export const useBannerStore = create<BannerStore>((set, get) => ({
  isBlockerDetected: false,
  setBlockerDetector: value => set(() => ({ isBlockerDetected: value })),
  isBannersReloading: false,
  canLoadBanners: false,
  setCanLoadBanners: value => set(() => ({ canLoadBanners: value })),
  bannerTopSource: BannerSource.Adriver,
  setBannerTopSource: value => set(() => ({ bannerTopSource: value })),
  bannerBottomSource: BannerSource.Adriver,
  setBannerBottomSource: value => set(() => ({ bannerBottomSource: value })),
  bannerBackgroundSource: BannerSource.Adriver,
  setBannerBackgroundSource: value =>
    set(() => ({ bannerBackgroundSource: value })),
  isAdriverTopBannerVisible: false,
  setIsAdriverTopBannerVisible: value =>
    set(() => ({ isAdriverTopBannerVisible: value })),
  resetBannersState: () =>
    set(() => {
      const bgLeft = document.querySelector('.lotriver-bg-left');
      const bgRight = document.querySelector('.lotriver-bg-right');

      bgLeft?.remove();
      bgRight?.remove();

      return {
        bannerTopSource: BannerSource.Adriver,
        bannerBottomSource: BannerSource.Adriver,
        bannerBackgroundSource: BannerSource.Adriver,
        isAdriverTopBannerVisible: false,
      };
    }),
  reloadBanners: () => {
    get().resetBannersState();
    set(() => ({ isBannersReloading: true }));
    setTimeout(() => set(() => ({ isBannersReloading: false })), 100);
  },
}));
